import { IImporterRepository } from '../domain/IImporterRepository'

export class GetImportDownloadUrl {
  constructor(private readonly importerRepository: IImporterRepository) {}

  execute(correlationFileId: string): Promise<string> {
    return this.importerRepository.getDownloadUrl(correlationFileId)
  }
}
